// @flow
'use strict';

import { connect } from 'react-redux';

import BotaoOpcaoDesconhecida from './botao_opcao_desconhecida';

export default connect<*, *, *, *, *, *>()(BotaoOpcaoDesconhecida);
